const fullStar = `<svg class="svg" width="18" height="18" viewbox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z" fill="#e38900"></path></svg>`;

function updateStars(rating) {
  const starsContainers = document.querySelectorAll('.stars');
  const fullStars = Math.floor(rating);
  const hasPartialStar = rating % 1 !== 0;
  const partialPercentage = Math.round((rating % 1) * 100);

  starsContainers.forEach((starsContainer) => {
    // Add stars to the stars container
    for (let i = 0; i < fullStars; i++) {
      starsContainer.innerHTML += fullStar;
    }
    if (hasPartialStar) {
      starsContainer.innerHTML += `<svg class="svg partial-star" width="18" height="18" viewbox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><defs><lineargradient id="half-grad${partialPercentage}"><stop offset="${partialPercentage}%" stop-color="#e38900"></stop><stop offset="${partialPercentage}%" stop-color="#afafaf" stop-opacity="1"></stop></lineargradient></defs><path d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z" fill="url(#half-grad${partialPercentage})"></path></svg>`;
    }
  });
}

document.addEventListener('DOMContentLoaded', async function () {
  try {
    const response = await fetch('/api/sa');

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Update rating text on every instance (hero banner + product cards)
    const ratingEls = document.querySelectorAll('.sa-rating');
    ratingEls.forEach((el) => (el.textContent = data.average_rating));

    // Update reviews count
    const formattedReviews = data.total_reviews.toLocaleString();
    const reviewsLabel = ratingEls[0]?.classList.contains('es') ? 'Reseñas' : 'Reviews';
    document.querySelectorAll('.sa-reviews').forEach((el) => (el.textContent = formattedReviews + ' ' + reviewsLabel));
    // Update stars dynamically
    updateStars(data.average_rating);

    // use scrollspy to slide in the rating container
    scrollSpy('.rating-container', 'slide-in-left');

    // fade in the per-card ratings as they scroll into view
    scrollSpy('.card-rating', 'fade-in');
  } catch (error) {
    console.error('Error fetching SA data:', error);
  }
});
